import Logger from "../../../utils/Logger";
const TAG = 'ThirdPartyMessageDispatcher';
export default class ThirdPartyMessageDispatcher {
    static dispatchMessage(type, targetOrigin, payload) {
        Logger.debug(TAG, `Dispatching ${type} message to the parent frame...`);
        if (window.parent) {
            window.parent.postMessage({
                type: type,
                ...payload
            }, targetOrigin);
        }
    }
}
//# sourceMappingURL=ThirdPartyMessageDispatcher.js.map